import ApiService from '../api'

class AboutStatsService {
  async getStats() {
    try {
      return await ApiService.get('/about/stats')
    } catch (error) {
      console.error('Get about stats error:', error)
      return { Success: false, Message: error.message || 'Failed to fetch about stats' }
    }
  }
}

export default new AboutStatsService()
